export default "__VITE_ASSET__a2c4bda1__"